import {useEventListener} from '../../../hooks/useEventListener';

export const useWindowResizeListener = (listener: (event: UIEvent) => void) => {
  useEventListener(window, 'resize', listener);
};
